import React from "react";
import {
  IonModal,
  IonCard,
  IonCardContent,
  IonIcon,
  IonButton,
} from "@ionic/react";
import {
  checkmarkCircle,
  giftOutline,
  restaurantOutline,
  starOutline,
  peopleOutline,
  arrowForwardOutline,
  shieldCheckmarkOutline,
} from "ionicons/icons";
import { liteWelcomeCallout } from "../../../utils/premiumLiteJourneyIntro";
import "./PremiumWelcomeModal.css";

const CONFETTI = [
  { top: 14, left: 18, color: "#f5b400", size: 7 },
  { top: 8, left: 44, color: "#65b165", size: 6 },
  { top: 22, left: 70, color: "#e26a6a", size: 7 },
  { top: 10, left: 86, color: "#5aa9e6", size: 6 },
  { top: 38, left: 8, color: "#b56be0", size: 6 },
  { top: 48, left: 92, color: "#f5b400", size: 7 },
  { top: 64, left: 16, color: "#5aa9e6", size: 6 },
  { top: 72, left: 80, color: "#65b165", size: 7 },
  { top: 30, left: 30, color: "#e26a6a", size: 5 },
  { top: 26, left: 58, color: "#b56be0", size: 5 },
];

// Premium Lite has the Premium subscription type, so this popup opens for it
// too: it must not promise what Lite doesn't include. For Lite the first step
// is the journey (client, 23/10/2026): `liteCallout` says which one and until
// when it can be changed (premiumLiteJourneyIntro.liteWelcomeCallout).
export const welcomeCopy = (lite, liteCallout = null) =>
  lite
    ? {
        plan: "Premium Lite",
        callout: liteCallout || liteWelcomeCallout(null),
        features: [
          { icon: restaurantOutline, text: "Piano alimentare personalizzato" },
          { icon: peopleOutline, text: "Community e progressi dedicati" },
        ],
      }
    : {
        plan: "Premium",
        callout:
          "Ora puoi personalizzare obiettivi, Percorso nutrizionale e alimentazione.",
        features: [
          { icon: restaurantOutline, text: "Piano alimentare personalizzato" },
          { icon: starOutline, text: "Contenuti Premium esclusivi" },
          { icon: peopleOutline, text: "Community e progressi dedicati" },
        ],
      };

export default function PremiumWelcomeModal({
  isOpen,
  onPrimary,
  onDismiss,
  title,
  subtitle,
  primaryLabel,
  lite = false,
  liteCallout = null,
}) {
  const copy = welcomeCopy(lite, liteCallout);

  return (
    <IonModal
      isOpen={isOpen}
      backdropDismiss={false}
      className="pwm-modal"
      onDidDismiss={onDismiss}
    >
      <IonCard className="pwm-card">
        <IonCardContent>
          <div className="pwm-confetti" aria-hidden="true">
            {CONFETTI.map((c, i) => (
              <span
                key={i}
                className="pwm-dot"
                style={{
                  top: `${c.top}px`,
                  left: `${c.left}%`,
                  background: c.color,
                  width: `${c.size}px`,
                  height: `${c.size}px`,
                }}
              />
            ))}
          </div>

          <div className="pwm-hero">
            <div className="pwm-checkCircle">
              <IonIcon icon={checkmarkCircle} className="pwm-checkIcon" />
            </div>
          </div>

          <h2 className="pwm-title">
            {title || (
              <>
                Benvenuto in
                <br />
                <span className="pwm-titleAccent">
                  Dieta Social {copy.plan}!
                </span>
              </>
            )}
          </h2>

          <p className="pwm-subtitle">
            {subtitle || (
              <>
                Il tuo accesso <span className="pwm-accent">{copy.plan}</span> è
                attivo.
              </>
            )}
          </p>

          <div className="pwm-callout">
            <IonIcon icon={giftOutline} className="pwm-calloutIcon" />
            <span className="pwm-calloutText">{copy.callout}</span>
          </div>

          <div className="pwm-features">
            {copy.features.map((feature) => (
              <div className="pwm-featureRow" key={feature.text}>
                <IonIcon icon={feature.icon} className="pwm-featureIcon" />
                <span className="pwm-featureText">{feature.text}</span>
              </div>
            ))}
          </div>

          <IonButton
            expand="block"
            className="pwm-primary"
            onClick={onPrimary}
          >
            {primaryLabel || "INIZIA ORA"}
            <IonIcon icon={arrowForwardOutline} slot="end" />
          </IonButton>

          <div className="pwm-footer">
            <IonIcon icon={shieldCheckmarkOutline} className="pwm-footerIcon" />
            <span>Sicuro, facile e senza impegno</span>
          </div>
        </IonCardContent>
      </IonCard>
    </IonModal>
  );
}
